import { render, staticRenderFns } from "./PWATestPage.vue?vue&type=template&id=b85bcca8&scoped=true&"
import script from "./PWATestPage.vue?vue&type=script&lang=js&"
export * from "./PWATestPage.vue?vue&type=script&lang=js&"
import style0 from "./PWATestPage.vue?vue&type=style&index=0&id=b85bcca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85bcca8",
  null
  
)

export default component.exports